import { Language } from 'prism-react-renderer';

import { urlPlaceHolder } from 'modules/chains/components/Snippets/const';

import { vrpcCurl, vrpcEthers, vrpcViem } from './templates';

export enum VrpcTechnology {
  ETHERS = 'ethers',
  VIEM = 'viem',
  CURL = 'curl',
}

const templates: Record<VrpcTechnology, [string, Language]> = {
  [VrpcTechnology.ETHERS]: [vrpcEthers, 'javascript'],
  [VrpcTechnology.VIEM]: [vrpcViem, 'javascript'],
  [VrpcTechnology.CURL]: [vrpcCurl, 'bash'],
};

const notPublicUrlsSuffix = '/apiKey';

interface IGetVrpcCodeParams {
  technology: VrpcTechnology;
  url?: string;
  shouldAddPrefix: boolean;
}

export const getVrpcCode = ({
  shouldAddPrefix,
  technology,
  url,
}: IGetVrpcCodeParams): { code: string; language: Language } => {
  const [template, language] = templates[technology];

  if (!url) {
    return { code: '', language };
  }

  const fullUrl = shouldAddPrefix ? url.concat(notPublicUrlsSuffix) : url;

  return { code: template.replace(urlPlaceHolder, fullUrl), language };
};
